module.exports = __webpack_public_path__ + "img/wmm6.prt.ee2b02ea.jpg";